import React, { PropTypes } from 'react'

export const Tabs = ({ heading, tabs, content, moduleClassName })=>{
  return(
    <section className={moduleClassName}>
      <header>
      {
        heading ? heading : null
      }
      <div className="filter form-group button-group" data-behavior="tabs">
        {tabs}
      </div>
      </header>
      {content}
    </section>
  )
}

export const Tab =({ props, isActive, switchTab })=>{
  if(typeof props === 'undefined') {
    return <span />
  }
  const { tabName, text, tabSizeClassName } = props
  const defaultClassname = 'button-filter-alt ' + tabSizeClassName
  const activeClassname = 'button-filter-alt '+ tabSizeClassName+ ' active'
  let currTabClassName = (isActive === tabName) ? activeClassname : defaultClassname
  return (
    <a onClick={switchTab.bind(null, tabName)} className={currTabClassName}>{text}</a>
  )
}

export const TabContent = ({ props, isActive })=>{
  if(typeof props === 'undefined') {
    return <span />
  }
  //console.info('=======>props',props)

  let defStyle = (isActive === props.contentName) ? { display: 'block' } : { display: 'none' }
  if(props.name) {
    return (
      <div id={props.name} style={defStyle}>
        {props.component}
      </div>
    )
  }else{
    return <span />
  }
}

export class TabsModule extends React.Component {
  constructor(props) {
    super(props)
    this.state = { active: '' }
  }
  static propTypes = {
    children: PropTypes.array
  }
  getActiveTab(d) {
    if(typeof d !== 'undefined') {
      Object.keys(d).forEach((i)=>{
        if(i === 'tabs') {
          let tabs = d[i] || []
          let key = d.key
          let dLen = tabs.length
          for(let j=0; j < dLen; j++) {
            let isActive = tabs[j].active ? tabs[j].active : false
            if(isActive === true) {
              this.setState({ active : (key + '' +j) })
            }
          }
        }
      })
    }
  }
  switchTab(name, e) {
    this.setState({ active: name })
    e.preventDefault()
  }
  componentWillMount() {
    if(this.state.active === '') {
      if(typeof this.props.data !== 'undefined') {
        this.getActiveTab.call(this, this.props.data)
      }
    }
  }
  render() {
    const { data } = this.props
    if(typeof data === 'undefined') {
      return <span />
    }
    let { tabSizeClassName='', moduleClassName='', tabs=[], heading, key } = data
    
    if(typeof tabs === 'undefined') {
      return <span />
    }

    let tabsArr = [], tabsContentArr = [], tabsCompArr = [], tabsHeadingArr = [], tabProps = {}
    
    if(typeof heading !== 'undefined') {
      tabsHeadingArr.push(heading.component)
    }

    tabProps.wrapKey = key + '-tabs'
    tabProps.contentWrapKey = tabProps.wrapKey + '-cont'
    moduleClassName = moduleClassName + ' ' + tabProps.wrapKey
    
    let tabsLen = tabs.length
    for(let i=0; i< tabsLen; i++) {
      //object key from tab config
      tabs[i].tabName = key + '' + i
      tabs[i].key = tabProps.wrapKey + '-' + i
      tabs[i].tabSizeClassName = tabSizeClassName
      tabsArr.push(<Tab key={tabs[i].key} props={tabs[i]} isActive={this.state.active} switchTab={this.switchTab.bind(this)} />)
      Object.keys(tabs[i]).forEach( (j)=>{
        let currTab = tabs[i][j]
        if(j === 'content') {
          //object key from tab config
          currTab.name = tabs[i].name
          currTab.contentName = tabs[i].tabName
          currTab.key = tabs[i].key + '-cont'
          tabsCompArr.push(<TabContent key={currTab.key} props={currTab} isActive={this.state.active} />)
        }
      })

      tabsContentArr = [
        <div key={tabProps.contentWrapKey} className="content">
          {tabsCompArr}
        </div>
      ]
    }
    
    //console.info('========> tabsHeadingArr',tabsHeadingArr)
    //console.info('========> tabsArr',tabsArr)
    //console.info('========> tabsCompArr',tabsCompArr)
    
    return(
      <Tabs key={tabProps.wrapKey} props={tabs} heading={tabsHeadingArr} tabs={tabsArr} content={tabsContentArr} moduleClassName={moduleClassName} />
    )
  }
}

export default TabsModule



/** WEBPACK FOOTER **
 ** ../app/components/common/Tabs.jsx
 **/